import { Component, Input, OnInit } from '@angular/core';
import { Auth } from '../../../../decorators/auth.decorator';
import { ModalClose } from '../../../../decorators/modal-close.decorator';
import { Subscribe } from '../../../../decorators/subscribe.decorator';
import { SearchParams } from '../../../../models/search-params';
import { UnsplashImage } from '../../../../models/unsplash-image';
import { UnsplashService } from '../../../../services/unsplash.service';

@Component({
  selector: 'app-join-modal',
  templateUrl: './join-modal.component.html',
  styleUrls: ['./join-modal.component.scss']
})

export class JoinModalComponent implements OnInit {
  @Input() searchParams: SearchParams;

  constructor(
    private unsplashService: UnsplashService,
  ) {
  }

  backgroundImage: string | UnsplashImage;

  ngOnInit(): void {
    this.unsplashService.randomPhoto(true).subscribe(image => {
      this.backgroundImage = image;
    });
  }

  @ModalClose()
  @Auth()
  @Subscribe()
  openMembershipModal() {}
}
